import { AangevraagdeLandelijkeFaciliteiten } from "@/entities/vestiging";
import { LandelijkeFaciliteitenHeader, LandelijkeFaciliteitenRow } from "@/features/faciliteiten/components/shared/landelijk";
import { AanvraagAction } from "./aanvraag-action.tsx";

type LandelijkeFaciliteitenRegievoerderProps = {
    dossierId: string;
    aanvraag: AangevraagdeLandelijkeFaciliteiten | null;
};

export function LandelijkeFaciliteitenRegievoerder({ dossierId, aanvraag }: LandelijkeFaciliteitenRegievoerderProps) {
    return (
        <div className="grid gap-4 pt-4">
            <LandelijkeFaciliteitenHeader readOnly={false} />
            {aanvraag?.status && <LandelijkeFaciliteitenRow status={aanvraag.status} toelichting={aanvraag.toelichting} />}
            <AanvraagAction dossierId={dossierId} status={aanvraag?.status} />
        </div>
    );
}
